import { wpRequest } from './requests';

const $ = jQuery.noConflict();

/**
 * Append additional posts to the page
 *
 * @param {number} nextPage - Next page number
 * @param {number} pageSize - Posts per page
 * @param {string} container - HTML selector to append posts to
 */
export async function morePosts(
   nextPage = 1,
   pageSize = 6,
   container = '.post-list'
) {
   const { moreButton } = window;
   const {
      content,
      maxPages,
   } = await wpRequest('get_next_posts', {
      page: nextPage,
      per_page: moreButton.query_args.posts_per_page || pageSize,
      query_args: moreButton.query_args,
      type: moreButton.type,
      partialType: moreButton.partialType,
      partial: moreButton.partial,
   });

   const $content = $(content);
   $(container).append(
      $content.hide()
   );
   $content.slideDown(400);

   if (maxPages <= nextPage) {
      $('.more-posts').fadeOut(200);
   }
   return content;
}

export default function setupMorePosts() {
   let currentPage = 1;
   const postsPerPage = parseInt(window._theme.postsPerPage, 10);
   $(document).ready(() => {
      $('.more-posts').on('click', (e) => {
         e.preventDefault();
         currentPage++;
         morePosts(currentPage, postsPerPage);
      });
   });
}
